import { InformationOutline24Icon } from "@vygruppen/spor-icon-react";
import { FC } from "react";
import { SemanticBox } from "shared/components/SemanticBox";
import { Checkbox, HStack, Text, DropsTooltip } from "shared/components/Spor";

export type EvaluationForm = {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  isDisabled: boolean;
};

export const EvaluationForm: FC<EvaluationForm> = ({
  checked,
  setChecked,
  isDisabled,
}) => (
  <SemanticBox
    variant="warning"
    header={
      <HStack justifyContent="space-between">
        <Text fontWeight="bold">
          Aktiver tilbakemeldingsskjema til togpersonell
        </Text>
        <DropsTooltip
          hasArrow
          placement="top"
          label="Ved å aktivere denne vil togpersonell få tilgang til et tilbakemeldingsskjema i Topas."
        >
          <InformationOutline24Icon />
        </DropsTooltip>
      </HStack>
    }
  >
    <Checkbox
      checked={isDisabled || checked}
      disabled={isDisabled}
      onCheckedChange={() => setChecked(!checked)}
    >
      Aktiver tilbakemeldingsskjema til togpersonell
    </Checkbox>
  </SemanticBox>
);
